import { ReactNode } from "react";
import { LoadingStatus } from "src/libs/fetcher";
import { useCardThemed } from "./useCardThemed";
import { type CardThemeIdentifier } from "./card-theme-utils";

export type ThemeHeadingProps = {
  themeId?: CardThemeIdentifier;
  children: ReactNode;
};

export function ThemeHeading({ themeId, children }: ThemeHeadingProps) {
  const { theme, status } = useCardThemed(themeId);

  if (status !== LoadingStatus.SUCCESS) {
    return null;
  }

  return <span style={{ color: theme.headingColor }}>{children}</span>;
}
